import React, { useState } from 'react'
import PropTypes from 'prop-types'
import Input from '../../generic/Input'
import Button from '../../generic/Button'
import { requestAPI } from '../../data/api'

const INITIAL_USER = {
	email: '',
	firstname: '',
	lastname: '',
	password: '',
	permission_level: 'customer',
}

export default function CreateUserForm({ onSuccess }, context) {
	const [newUser, setNewUser] = useState(INITIAL_USER)
	const [loadingNewUser, setLoadingNewUser] = useState(false)
	const [newUserErrors, setNewUserErrors] = useState([])

	const createUser = async () => {
		setLoadingNewUser(true)
		setNewUserErrors([])

		try {
			const res = await requestAPI('/authentication/signup', 'POST', newUser)

			if (res.status === 'error') {
				setNewUserErrors(res.errors || [])
			} else {
				setNewUser({ ...INITIAL_USER })
				setNewUserErrors([])
				onSuccess()
			}
		} catch (err) {
			setNewUserErrors([
				context.gettext('admin.settings.error_generic') ||
					'Something went wrong',
			])
		} finally {
			setLoadingNewUser(false)
		}
	}

    const isValid = newUser.firstname && newUser.lastname && newUser.email && newUser.password

	return (
		<div
			style={{
				opacity: loadingNewUser ? 0.5 : 1,
				transition: 'opacity .4s',
			}}
		>
			{newUserErrors.map((error, i) => (
				<div className='warning' key={i}>
					{error}
				</div>
			))}

			<Input
				value={newUser.firstname}
				onChange={(e) => {
					const { value } = e.target
					setNewUser((u) => ({ ...u, firstname: value }))
				}}
				type='text'
				placeholder={context.gettext('admin.settings.firstname')}
			/>

			<Input
				value={newUser.lastname}
				onChange={(e) => {
					const { value } = e.target
					setNewUser((u) => ({ ...u, lastname: value }))
				}}
				type='text'
				placeholder={context.gettext('admin.settings.lastname')}
			/>

			<Input
				value={newUser.email}
				onChange={(e) => {
					const { value } = e.target
					setNewUser((u) => ({
						...u,
						email: (value || '').trim().toLowerCase(),
					}))
				}}
				type='email'
				placeholder={context.gettext('admin.settings.email')}
			/>

			<Input
				value={newUser.password}
				onChange={(e) => {
					const { value } = e.target
					setNewUser((u) => ({ ...u, password: value }))
				}}
				type='password'
				placeholder={context.gettext('admin.settings.password')}
			/>

			<select
				className='inp inp-select'
				value={newUser.permission_level}
				onChange={(e) => {
					const { value } = e.target
					setNewUser((u) => ({ ...u, permission_level: value }))
				}}
			>
				<option value='customer'>Client</option>
				<option value='photographer'>Stringer</option>
				<option value='admin'>
					{context.gettext('admin.settings.role_administrator')}
				</option>
				<option value='agent'>
					{context.gettext('admin.settings.role_agent')}
				</option>
			</select>

			<Button disabled={loadingNewUser || !isValid} onClick={createUser}>
				{context.gettext('admin.settings.create_user')}
			</Button>
		</div>
	)
}

CreateUserForm.contextTypes = {
	gettext: PropTypes.func.isRequired,
}

CreateUserForm.propTypes = {
	onSuccess: PropTypes.func.isRequired,
}
